import React, {useEffect} from 'react';
import IconSvg from '../../../img/trip_planner/steps/step_1.svg';
import useTranslate from "../../../../../hooks/useTranslate";
import moment from 'moment';
import CitySearchInput, {CityOption} from "../../CitySearchInput";
import ValaiDateRangePicker from "../../ValaiDateRangePicker";

type Props = {
    onSelect: (selectedOption: CityOption) => void;
    selectedDestinationId?: number;
    arrivalDatetime: string;
    departureDatetime: string;
    onDateChange: (arrival: string, departure: string) => void;
    maxDays?: number; // Maximum number of days that can be selected
}

const Step1Destination: React.FC<Props> = ({onSelect, selectedDestinationId, arrivalDatetime, departureDatetime, onDateChange, maxDays}) => {
    const { t } = useTranslate();

    const handleDateChange = (startDate: moment.Moment, endDate: moment.Moment) => {
        onDateChange(
            startDate.format("YYYY-MM-DD HH:mm"),
            endDate.format("YYYY-MM-DD HH:mm")
        );
    };

    return (
        <div className="space-y-6">
            <div className="text-center mb-8">
                <div className="w-20-h mx-auto mb-4 relative">
                    <img
                        src={IconSvg}
                        alt="Where are you going?"
                        className="w-full h-full object-contain"
                    />
                    <div className="absolute inset-0" style={{ backgroundColor: 'var(--primary-color)', mixBlendMode: 'lighten' }} />
                </div>
                <h2 className="text-2xl font-semibold mb-2 syne-fm">{t('trips.createNewTrip.form.destination.city.placeholder')}</h2>
            </div>

            <div className="flex flex-col md:flex-row gap-4">
                {/* City Search Input */}
                <CitySearchInput
                    selectedCityId={selectedDestinationId}
                    onCitySelect={onSelect}
                    className="flex-1"
                    showValaiStyle={true}
                />

                {/* Date Range Picker */}
                <ValaiDateRangePicker
                    startDate={moment(arrivalDatetime)}
                    endDate={moment(departureDatetime)}
                    onDateChange={handleDateChange}
                    className="flex-1"
                    maxDays={maxDays}
                />
            </div>
        </div>
    );
};

export default Step1Destination;